import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { EnumCodigosTwTcAcciones } from '../../_importacion/solicitudes/types/enum';
import { DeclaracionSuplementariaWrapperEditComponent } from './declaracionessuplementarias/declaracionsuplementaria-wrapper-edit/declaracionsuplementaria-wrapper-edit.component';
import { DeclaracionSuplementariaWrapperComponent } from './declaracionessuplementarias/declaracionsuplementaria-wrapper/declaracionsuplementaria-wrapper.component';
import { DestinoControlEditComponent } from './destinoscontrol/destinocontrol-edit.component';
import { DestinoControlListComponent } from './destinoscontrol/destinocontrol-list.component';
import { ErrorTracesEditComponent } from './errorestraces/errortraces-edit.component';
import { ErrorTracesListComponent } from './errorestraces/errortraces-list.component';
import { InspectorExtrajeroEditComponent } from './inspectoresextranjeros/inspectorextranjero-edit.component';
import { InspectorExtrajeroListComponent } from './inspectoresextranjeros/inspectorextranjero-list.component';
import { InstalacionAutorizadaEditComponent } from './instalacionesautorizadas/instalacionautorizada-edit.component';
import { InstalacionAutorizadaListComponent } from './instalacionesautorizadas/instalacionautorizada-list.component';
import { MrnEditComponent } from './mrns/mrn-edit.component';
import { MrnListComponent } from './mrns/mrn-list.component';
import { MunicipioEditComponent } from './municipios/municipios-edit.component';
import { MunicipioListComponent } from './municipios/municipios-list.component';
import { NumeroSeguridadListComponent } from './numerosseguridad/numerosseguridad-list.component';
import { PaisEditComponent } from './paises/pais-edit.component';
import { PaisListComponent } from './paises/pais-list.component';
import { PuntoControlEditComponent } from './puntoscontrol/puntocontrol-edit.component';
import { PuntoControlListComponent } from './puntoscontrol/puntocontrol-list.component';
import { PuntoInspeccionWrapperEditComponent } from './puntosinspeccion/puntoinspeccion-wrapper-edit/puntoinspeccion-wrapper-edit.component';
import { PuntoInspeccionWrapperSearchComponent } from './puntosinspeccion/puntoinspeccion-wrapper-search/puntoinspeccion-wrapper-search.component';
import { PorcentajeSemanalWrapperListEditComponent } from './puntosinspeccion/porcentajesemanal-wrapper-list-edit/porcentajesemanal-wrapper-list-edit.component';
import { CargasSolicitudesPcfExWrapperComponent } from './cargassolicitudespcfex/cargassolicitudespcfex-wrapper/cargassolicitudespcfex-wrapper.component';
import { SolicitudEditComponent } from './solicitudes/solicitud-edit.component';
import { SolicitudListComponent } from './solicitudes/solicitud-list.component';
import { TipoBultoEditComponent } from './tipobulto/tipobulto-edit.component';
import { TipoBultoListComponent } from './tipobulto/tipobulto-list.component';
import { TipoDocumentacionEditComponent } from './tipodocumentacion/tipodocumentacion-edit.component';
import { TipoDocumentacionListComponent } from './tipodocumentacion/tipodocumentacion-list.component';
import { TipoDocumentacionCamWrapperEditComponent } from './tipodocumentacioncam/tipodocumentacioncam-wrapper-edit/tipodocumentacioncam-wrapper-edit.component';
import { TipoDocumentacionCamWrapperComponent } from './tipodocumentacioncam/tipodocumentacioncam-wrapper/tipodocumentacioncam-wrapper.component';
import { TipoDocumentacionExEditComponent } from './tipodocumentacionex/tipodocumentacionex-edit.component';
import { TipoDocumentacionExListComponent } from './tipodocumentacionex/tipodocumentacionex-list.component';
import { TrailblazerListComponent } from './trailblazer/trailblazer-list.component';
import { TratamientoDesinfeccionWrapperEditComponent } from './tratamientodesinfeccion/tratamientodesinfeccion-wrapper-edit/tratamientodesinfeccion-wrapper-edit.component';
import { TratamientoDesinfeccionWrapperComponent } from './tratamientodesinfeccion/tratamientodesinfeccion-wrapper/tratamientodesinfeccion-wrapper.component';
import { UbicacionEditComponent } from './ubicaciones/ubicacion-edit.component';
import { UbicacionListComponent } from './ubicaciones/ubicacion-list.component';
import { SolicitudExListComponent } from './solicitudesex/solicitudesex-list/solicitudesex-list.component';
import { SolicitudesexWrapperEditComponent } from './solicitudesex/solicitudesex-wrapper-edit/solicitudesex-wrapper-edit.component';
import { LoginGuard, ActionGuard } from '../../core/_infrastructure/classes/guards/main.guard';
import { AutoridadControlEditComponent } from './puntoscontrol/autoridadcontrol-edit.component';
import { DialogMode } from '../../_campanias/types/enum';
import { EmpresadeshidratadoraWrapperComponent } from './empresasdeshidratadoras/empresadeshidratadora-wrapper/empresadeshidratadora-wrapper.component';
import { EmpresaDeshidratadoraEditComponent } from './empresasdeshidratadoras/empresadeshidratadora-edit/empresadeshidratadora-edit.component';
import { TransicionEstadoUdInspeccionCamWrapperComponent } from './transicionestadosudsinspeccioncam/transicionestadoudinspeccioncam-wrapper/transicionestadoudinspeccioncam-wrapper.component';
import { TransicionEstadoUdInspeccionCamWrapperEditComponent } from './transicionestadosudsinspeccioncam/transicionestadoudinspeccioncam-wrapper-edit/transicionestadoudinspeccioncam-wrapper-edit.component';
import { CertSedeExporSLListComponent } from './certificadosSedeExporSL/certSedeExporSL-list.component';
import { ComunidadAutonomaWrapperComponent } from './comunidadesautonomas/comunidadautonoma-wrapper/comunidadautonoma-wrapper.component';
import { ComunidadAutonomaEditComponent } from './comunidadesautonomas/comunidadautonoma-edit/comunidadautonoma-edit.component';
import { ComunidadAutonomaWrapperEditComponent } from './comunidadesautonomas/comunidadautonoma-wrapper-edit/comunidadautonoma-wrapper-edit.component';

const generalRoutes: Routes = [
    //PUNTOS DE INSPECCIÓN
    {
        path: 'mantenimiento/general/puntosinspeccion',
        data: {
            breadcrumb: 'Puntos de Inspección',
            menu0: 'MANTENIMIENTO',
            menu1: 'General',
        },
        children: [
            {
                path: '',
                component: PuntoInspeccionWrapperSearchComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    actionCode: EnumCodigosTwTcAcciones.MANTENIMIENTOS,
                },
            },
            {
                path: 'edit/:id',
                component: PuntoInspeccionWrapperEditComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    breadcrumb: 'Editar Punto Inspección',
                    actionCode: EnumCodigosTwTcAcciones.MANTENIMIENTOS,
                },
            },
            {
                path: 'create',
                component: PuntoInspeccionWrapperEditComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    breadcrumb: 'Nuevo Punto Inspección',
                    actionCode: EnumCodigosTwTcAcciones.MANTENIMIENTOS,
                },
            },
            {
                path: 'porcentajes',
                component: PorcentajeSemanalWrapperListEditComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    breadcrumb: 'Porcentajes Semanales',
                    actionCode: EnumCodigosTwTcAcciones.MANTENIMIENTOS,
                },
            },
        ],
    },
    //CARGAS SOLICITUDES PUNTOS DE INSPECCIÓN
    {
        path: 'mantenimiento/general/cargassolicitudespcfex',
        data: {
            breadcrumb: 'Distribución de Solicitudes Export UK con Inspección documental',
            menu0: 'MANTENIMIENTO',
            menu1: 'General',
        },
        children: [
            {
                path: '',
                component: CargasSolicitudesPcfExWrapperComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    actionCode: EnumCodigosTwTcAcciones.MANTENIMIENTOS,
                },
            },
        ],
    },
    //UBICACIONES
    {
        path: 'mantenimiento/general/ubicaciones',
        data: {
            breadcrumb: 'Ubicaciones',
            menu0: 'MANTENIMIENTO',
            menu1: 'General',
        },
        children: [
            {
                path: '',
                component: UbicacionListComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    actionCode: EnumCodigosTwTcAcciones.MANTENIMIENTOS,
                },
            },
            {
                path: 'edit/:id',
                component: UbicacionEditComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    breadcrumb: 'Editar Ubicación',
                    actionCode: EnumCodigosTwTcAcciones.MANTENIMIENTOS,
                },
            },
            {
                path: 'create',
                component: UbicacionEditComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    breadcrumb: 'Nueva Ubicación',
                    actionCode: EnumCodigosTwTcAcciones.MANTENIMIENTOS,
                },
            },
        ],
    },
    //TRAILBLAZER
    {
        path: 'mantenimiento/general/trailblazer',
        data: {
            breadcrumb: 'Trailblazer',
            menu0: 'MANTENIMIENTO',
            menu1: 'General',
        },
        children: [
            {
                path: '',
                component: TrailblazerListComponent,
                canActivate: [LoginGuard()],
            },
        ],
    },

    //PUNTOS CONTROL
    {
        path: 'mantenimiento/general/puntoscontrol',
        data: {
            breadcrumb: 'Puntos de Control',
            menu0: 'MANTENIMIENTO',
            menu1: 'General',
        },
        children: [
            {
                path: '',
                component: PuntoControlListComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    actionCode: EnumCodigosTwTcAcciones.MANTENIMIENTOS,
                },
            },
            {
                path: 'edit/:id',

                data: {
                    breadcrumb: 'Editar Punto de Control',
                    actionCode: EnumCodigosTwTcAcciones.MANTENIMIENTOS,
                },

                children: [
                    {
                        path: '',
                        component: PuntoControlEditComponent,
                        canActivate: [LoginGuard(), ActionGuard()],
                        data: {
                            actionCode: EnumCodigosTwTcAcciones.MANTENIMIENTOS,
                        },
                    },
                    {
                        path: 'autoridadcontrol/edit/:idautoridad',
                        component: AutoridadControlEditComponent,
                        canActivate: [LoginGuard(), ActionGuard()],
                        data: {
                            breadcrumb: 'Editar Autoridad Control',
                            actionCode: EnumCodigosTwTcAcciones.MANTENIMIENTOS,
                        },
                    },
                    {
                        path: 'autoridadcontrol/create',
                        component: AutoridadControlEditComponent,
                        canActivate: [LoginGuard(), ActionGuard()],
                        data: {
                            breadcrumb: 'Nueva Autoridad Control',
                            actionCode: EnumCodigosTwTcAcciones.MANTENIMIENTOS,
                        },
                    },
                ],
            },
            {
                path: 'create',
                component: PuntoControlEditComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    breadcrumb: 'Nuevo Punto Control',
                    actionCode: EnumCodigosTwTcAcciones.MANTENIMIENTOS,
                },
            },
        ],
    },

    //DESTINOS CONTROL
    {
        path: 'mantenimiento/general/destinoscontrol',
        data: {
            breadcrumb: 'Destinos de Control',
            menu0: 'MANTENIMIENTO',
            menu1: 'General',
        },
        children: [
            {
                path: '',
                component: DestinoControlListComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    actionCode: EnumCodigosTwTcAcciones.MANTENIMIENTOS,
                },
            },
            {
                path: 'edit/:id',
                component: DestinoControlEditComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    breadcrumb: 'Editar Destino de Control',
                    actionCode: EnumCodigosTwTcAcciones.MANTENIMIENTOS,
                },
            },
            {
                path: 'create',
                component: DestinoControlEditComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    breadcrumb: 'Nuevo Destino de Control',
                    actionCode: EnumCodigosTwTcAcciones.MANTENIMIENTOS,
                },
            },
        ],
    },

    //INSTALACIONES AUTORIZADAS
    {
        path: 'mantenimiento/general/instalacionesautorizadas',
        data: {
            breadcrumb: 'Instalaciones Autorizadas',
            menu0: 'MANTENIMIENTO',
            menu1: 'General',
        },
        children: [
            {
                path: '',
                component: InstalacionAutorizadaListComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    actionCode: EnumCodigosTwTcAcciones.MANTENIMIENTOS,
                },
            },
            {
                path: 'edit/:id',
                component: InstalacionAutorizadaEditComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    breadcrumb: 'Editar Instalación Autorizada',
                    actionCode: EnumCodigosTwTcAcciones.MANTENIMIENTOS,
                },
            },
            {
                path: 'create',
                component: InstalacionAutorizadaEditComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    breadcrumb: 'Nueva Instalación Autorizada',
                    actionCode: EnumCodigosTwTcAcciones.MANTENIMIENTOS,
                },
            },
        ],
    },

    //TIPO DOCUMENTACION
    {
        path: 'mantenimiento/general/tipodocumentacion',
        data: {
            breadcrumb: 'Tipos Documentación',
            menu0: 'MANTENIMIENTO',
            menu1: 'General',
        },
        children: [
            {
                path: '',
                component: TipoDocumentacionListComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    actionCode: EnumCodigosTwTcAcciones.MANTENIMIENTOS,
                },
            },
            {
                path: 'edit/:id',
                component: TipoDocumentacionEditComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    breadcrumb: 'Editar Tipo de Documentación',
                    actionCode: EnumCodigosTwTcAcciones.MANTENIMIENTOS,
                },
            },
            {
                path: 'create',
                component: TipoDocumentacionEditComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    breadcrumb: 'Nuevo Tipo de Documentación',
                    actionCode: EnumCodigosTwTcAcciones.MANTENIMIENTOS,
                },
            },
        ],
    },

    // TIPOS DOCUMENTACIÓN CAMPAÑAS
    {
        path: 'mantenimiento/general/tipodocumentacioncam',
        data: {
            breadcrumb: 'Tipo Documentación Campañas',
            menu0: 'MANTENIMIENTO',
        },
        children: [
            {
                path: '',
                component: TipoDocumentacionCamWrapperComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    actionCode: EnumCodigosTwTcAcciones.MANTENIMIENTOS,
                },
            },
            {
                path: 'edit/:id',
                component: TipoDocumentacionCamWrapperEditComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    breadcrumb: 'Editar Tipo de Documentación Campañas',
                    actionCode: EnumCodigosTwTcAcciones.MANTENIMIENTOS,
                },
            },
            {
                path: 'create',
                component: TipoDocumentacionCamWrapperEditComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    breadcrumb: 'Nuevo Tipo de Documentación Campañas',
                    actionCode: EnumCodigosTwTcAcciones.MANTENIMIENTOS,
                },
            },
        ],
    },

    // TIPOS DOCUMENTACIÓN EXPORTACIÓN
    {
        path: 'mantenimiento/general/tipodocumentacionex',
        data: {
            breadcrumb: 'Tipos Documentación Ex',
            menu0: 'MANTENIMIENTO',
            menu1: 'General',
        },
        children: [
            {
                path: '',
                component: TipoDocumentacionExListComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    actionCode: EnumCodigosTwTcAcciones.MANTENIMIENTOS,
                },
            },
            {
                path: 'edit/:id',
                component: TipoDocumentacionExEditComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    breadcrumb: 'Editar Tipo de Documentación Ex',
                    actionCode: EnumCodigosTwTcAcciones.MANTENIMIENTOS,
                },
            },
            {
                path: 'create',
                component: TipoDocumentacionExEditComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    breadcrumb: 'Nuevo Tipo de Documentación Ex',
                    actionCode: EnumCodigosTwTcAcciones.MANTENIMIENTOS,
                },
            },
        ],
    },

    //PAISES
    {
        path: 'mantenimiento/general/paises',
        data: {
            breadcrumb: 'Países ',
            menu0: 'MANTENIMIENTO',
            menu1: 'General',
        },
        children: [
            {
                path: '',
                component: PaisListComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    actionCode: EnumCodigosTwTcAcciones.MANTENIMIENTOS,
                },
            },
            {
                path: 'edit/:id',
                component: PaisEditComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    breadcrumb: 'Editar País',
                    actionCode: EnumCodigosTwTcAcciones.MANTENIMIENTOS,
                },
            },
            {
                path: 'create',
                component: PaisEditComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    breadcrumb: 'Nuevo País',
                    actionCode: EnumCodigosTwTcAcciones.MANTENIMIENTOS,
                },
            },
        ],
    },

    {
        path: 'mantenimiento/general/comunidadautonoma',
        data: {
            breadcrumb: 'Comunidades Autónomas',
            //menu0: 'MANTENIMIENTO',
            //menu1: 'General',
        },
        children: [
            {
                path: '',
                component: ComunidadAutonomaWrapperComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    actionCode: EnumCodigosTwTcAcciones.MANTENIMIENTOS,
                },
            },
            {
                path: 'edit/:id',
                component: ComunidadAutonomaWrapperEditComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    breadcrumb: 'Editar Comunidad Autónoma',
                    actionCode: EnumCodigosTwTcAcciones.MANTENIMIENTOS,
                },
            },
        ],
    },
    //SOLICITUDES IMPORTACIÓN
    {
        path: 'mantenimiento/general/solicitudes',
        data: {
            breadcrumb: 'Solicitudes',
            menu0: 'MANTENIMIENTO',
            menu1: 'General',
        },
        children: [
            {
                path: '',
                component: SolicitudListComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    actionCode: EnumCodigosTwTcAcciones.MANTENIMIENTOS,
                },
            },
            {
                path: 'edit/:id',
                component: SolicitudEditComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    breadcrumb: 'Editar Solicitud',
                    actionCode: EnumCodigosTwTcAcciones.MANTENIMIENTOS,
                },
            },
        ],
    },

    //SOLICITUDES EXPORTACION
    {
        path: 'mantenimiento/general/solicitudesEx',
        data: {
            breadcrumb: 'Solicitudes Exp.',
            menu0: 'MANTENIMIENTO',
            menu1: 'General',
        },
        children: [
            {
                path: '',
                component: SolicitudExListComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    actionCode: EnumCodigosTwTcAcciones.MANTENIMIENTOS,
                },
            },
            {
                path: 'edit/:id',
                component: SolicitudesexWrapperEditComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    breadcrumb: 'Editar Solicitud',
                    actionCode: EnumCodigosTwTcAcciones.MANTENIMIENTOS,
                },
            },
        ],
    },

    //TIPOS BULTO
    {
        path: 'mantenimiento/general/tipobulto',
        data: {
            breadcrumb: 'Tipos de Bulto',
            menu0: 'MANTENIMIENTO',
            menu1: 'General',
        },
        children: [
            {
                path: '',
                component: TipoBultoListComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    actionCode: EnumCodigosTwTcAcciones.MANTENIMIENTOS,
                },
            },
            {
                path: 'edit/:id',
                component: TipoBultoEditComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    breadcrumb: 'Editar Tipo de Bulto',
                    actionCode: EnumCodigosTwTcAcciones.MANTENIMIENTOS,
                },
            },
            {
                path: 'create',
                component: TipoBultoEditComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    breadcrumb: 'Nuevo Tipo de Bulto',
                    actionCode: EnumCodigosTwTcAcciones.MANTENIMIENTOS,
                },
            },
        ],
    },

    //MRN
    {
        path: 'mantenimiento/general/mrn',
        data: {
            breadcrumb: 'Mrn',
            menu0: 'MANTENIMIENTO',
            menu1: 'General',
        },
        children: [
            {
                path: '',
                component: MrnListComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    actionCode: EnumCodigosTwTcAcciones.MANTENIMIENTOS,
                },
            },
            {
                path: 'edit/:mrn',
                component: MrnEditComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    breadcrumb: 'Editar Mrn',
                    actionCode: EnumCodigosTwTcAcciones.MANTENIMIENTOS,
                },
            },
        ],
    },

    //INSPECTORES EXTRANJEROS
    {
        path: 'mantenimiento/general/inspectorextranjero',
        data: {
            breadcrumb: 'Inspectores No nacionales',
            menu0: 'MANTENIMIENTO',
            menu1: 'General',
        },
        children: [
            {
                path: '',
                component: InspectorExtrajeroListComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    actionCode: EnumCodigosTwTcAcciones.MANTENIMIENTOS,
                },
            },
            {
                path: 'edit/:id',
                component: InspectorExtrajeroEditComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    breadcrumb: 'Editar Inspector No nacional',
                    actionCode: EnumCodigosTwTcAcciones.MANTENIMIENTOS,
                },
            },
            {
                path: 'create',
                component: InspectorExtrajeroEditComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    breadcrumb: 'Nuevo Inspector No nacional',
                    actionCode: EnumCodigosTwTcAcciones.MANTENIMIENTOS,
                },
            },
        ],
    },

    //MUNICIPIOS
    {
        path: 'mantenimiento/general/municipios',
        data: {
            breadcrumb: 'Municipios',
            menu0: 'MANTENIMIENTO',
            menu1: 'General',
        },
        children: [
            {
                path: '',
                component: MunicipioListComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    actionCode: EnumCodigosTwTcAcciones.MANTENIMIENTOS,
                },
            },
            {
                path: 'edit/:id',
                component: MunicipioEditComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    breadcrumb: 'Editar Municipio',
                    actionCode: EnumCodigosTwTcAcciones.MANTENIMIENTOS,
                },
            },
        ],
    },

    //NÚMEROS SEGURIDAD
    {
        path: 'mantenimiento/general/numerosseguridad',
        data: {
            breadcrumb: 'Números Seguridad',
            menu0: 'MANTENIMIENTO',
            menu1: 'General',
        },
        children: [
            {
                path: '',
                component: NumeroSeguridadListComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    actionCode: EnumCodigosTwTcAcciones.MANTENIMIENTOS,
                },
            },
        ],
    },

    //ERRORES TRACES
    {
        path: 'mantenimiento/general/errorestraces',
        data: {
            breadcrumb: 'Errores Traces',
            menu0: 'MANTENIMIENTO',
            menu1: 'General',
        },
        children: [
            {
                path: '',
                component: ErrorTracesListComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    actionCode: EnumCodigosTwTcAcciones.MANTENIMIENTOS,
                },
            },
            {
                path: 'edit/:id',
                component: ErrorTracesEditComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    breadcrumb: 'Editar Error Traces',
                    actionCode: EnumCodigosTwTcAcciones.MANTENIMIENTOS,
                },
            },
            {
                path: 'create',
                component: ErrorTracesEditComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    breadcrumb: 'Nuevo Error Traces',
                    actionCode: EnumCodigosTwTcAcciones.MANTENIMIENTOS,
                },
            },
        ],
    },

    // EMPRESA DESHIDRATADORA
    {
        path: 'mantenimiento/general/empresasdeshidratadoras',
        data: {
            breadcrumb: 'Empresas Deshidratadoras',
            menu0: 'MANTENIMIENTO',
            menu1: 'General',
        },
        children: [
            {
                path: '',
                component: EmpresadeshidratadoraWrapperComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    mode: DialogMode.Basic,
                    actionCode: EnumCodigosTwTcAcciones.MANTENIMIENTOS,
                },
            },
            {
                path: 'view/:id',
                component: EmpresaDeshidratadoraEditComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    readonly: true,
                    breadcrumb: 'Consultar Empresa Deshidratadora',
                    actionCode: EnumCodigosTwTcAcciones.MANTENIMIENTOS,
                },
            },
            {
                path: 'edit/:id',
                component: EmpresaDeshidratadoraEditComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    breadcrumb: 'Editar Empresa Deshidratadora',
                    actionCode: EnumCodigosTwTcAcciones.MANTENIMIENTOS,
                },
            },
            {
                path: 'create',
                component: EmpresaDeshidratadoraEditComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    breadcrumb: 'Nueva Empresa Deshidratadora',
                    actionCode: EnumCodigosTwTcAcciones.MANTENIMIENTOS,
                },
            },
        ],
    },

    // DECLARACIONES SUPLEMENTARIAS
    {
        path: 'mantenimiento/general/declaracionsuplementaria',
        data: {
            breadcrumb: 'Declaraciones Suplementarias',
            menu0: 'MANTENIMIENTO',
            menu1: 'General',
        },
        children: [
            {
                path: '',
                component: DeclaracionSuplementariaWrapperComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    actionCode: EnumCodigosTwTcAcciones.MANTENIMIENTOS,
                },
            },
            {
                path: 'edit/:id',
                component: DeclaracionSuplementariaWrapperEditComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    breadcrumb: 'Editar Declaración Suplementaria',
                    actionCode: EnumCodigosTwTcAcciones.MANTENIMIENTOS,
                },
            },
            {
                path: 'create',
                component: DeclaracionSuplementariaWrapperEditComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    breadcrumb: 'Crear Declaración Suplementaria',
                    actionCode: EnumCodigosTwTcAcciones.MANTENIMIENTOS,
                },
            },
        ],
    },

    // TRATAMIENTOS DESINFECCIÓN
    {
        path: 'mantenimiento/general/tratamientodesinfeccion',
        data: {
            breadcrumb: 'Tratamiento Desinfección',
            menu0: 'MANTENIMIENTO',
            menu1: 'General',
        },
        children: [
            {
                path: '',
                component: TratamientoDesinfeccionWrapperComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    actionCode: EnumCodigosTwTcAcciones.MANTENIMIENTOS,
                },
            },
            {
                path: 'edit/:id',
                component: TratamientoDesinfeccionWrapperEditComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    breadcrumb: 'Editar Tratamiento Desinfección',
                    actionCode: EnumCodigosTwTcAcciones.MANTENIMIENTOS,
                },
            },
            {
                path: 'create',
                component: TratamientoDesinfeccionWrapperEditComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    breadcrumb: 'Crear Tratamiento Desinfección',
                    actionCode: EnumCodigosTwTcAcciones.MANTENIMIENTOS,
                },
            },
        ],
    },

    // TRANSICIÓN DE ESTADOS DE UNIDADES DE INSPECCIÓN (CAMPAÑAS)
    {
        path: 'mantenimiento/general/transicionestadoudinspeccioncam',
        data: {
            breadcrumb: 'Transición Estados Uds. Ins.',
            menu0: 'MANTENIMIENTO',
            menu1: 'General',
        },
        children: [
            {
                path: '',
                component: TransicionEstadoUdInspeccionCamWrapperComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    actionCode: EnumCodigosTwTcAcciones.MANTENIMIENTOS,
                },
            },
            {
                path: 'edit/:id',
                component: TransicionEstadoUdInspeccionCamWrapperEditComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    breadcrumb: 'Editar Transición de Estados Uds. Ins.',
                    actionCode: EnumCodigosTwTcAcciones.MANTENIMIENTOS,
                },
            },
            {
                path: 'create',
                component: TransicionEstadoUdInspeccionCamWrapperEditComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    breadcrumb: 'Crear Transición de Estados Uds. Ins.',
                    actionCode: EnumCodigosTwTcAcciones.MANTENIMIENTOS,
                },
            },
        ],
    },

    //CERTIFICADOS SEDE EXPORTACIÓN SL
    {
        path: 'mantenimiento/general/certificadosSedeExporSL',
        data: {
            breadcrumb: 'CFs Sede SL',
            menu0: 'MANTENIMIENTO',
            menu1: 'General',
        },
        children: [
            {
                path: '',
                component: CertSedeExporSLListComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    actionCode: EnumCodigosTwTcAcciones.MANTENIMIENTOS,
                },
            },
        ],
    },
];
@NgModule({
    imports: [RouterModule.forChild(generalRoutes)],
    exports: [RouterModule],
})
export class GeneralRoutingModule {}
